<template>
  <div class="wrapper">
    <chat-header></chat-header>
    <chat-contents
      :form-count="formCount"
      @form-countup="formCountup"
    ></chat-contents>
    <chat-footer
      :total="formCount.total"
      :answer="formCount.answer"
    ></chat-footer>
  </div>
</template>

<script>
import ChatHeader from './ChatHeader'
import ChatContents from './ChatContents'
import ChatFooter from './ChatFooter'
import PathMixin from '../mixins/PathMixin'

export default {
  name: 'ChatWrap',
  mixins: [PathMixin],
  components: {
    ChatHeader,
    ChatContents,
    ChatFooter
  },
  data: function () {
    return {
      formCount: {
        total: 10,
        answer: 0
      }
    }
  },
  beforeCreate: function () {},
  created () {
    if (this.is004Path || this.is005Path) {
      // LP004 or 005の場合は、残回答数を5に変更
      this.formCount.total = 5
    }
  },
  mounted: function () {},
  beforeUpdate: function () {},
  updated: function () {},
  methods: {
    formCountup: function () {
      this.formCount.answer += 1
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChatWrap.vue